import {
    AccountProvisionTriggerSubSource,
    CompanyAccountProvisioningProductType,
    RoleType
} from '../constants-types/Enums';
import { Name } from './Name';

// V4 API SERVER MODELS

export class UserCreateServer {
    firstName: string;
    middleName?: string;
    lastName: string;
    email: string;
    userRole: RoleType;
    phone: string;
    jobTitle: string;
    defaultLanguage: string;
    defaultFolderId: string;
    canAccessCognitive: boolean;
    personId?: string;
}

export interface UserCreateAccountProvisioningServer {
    name: Name;
    email: string;
    userRole: RoleType;
    phone: string;
    jobTitle: string;
    defaultLanguage: string;
    defaultFolderId: string;
    canAccessCognitive: boolean;
    apiCompanyId: string;
    teamId: string;
    accountProvisionTriggerSubsource: AccountProvisionTriggerSubSource;
    product: CompanyAccountProvisioningProductType;
}

export class UserUpdateServer extends UserCreateServer {
    userId: string;
    isEnabled: boolean;
}

export class UserAccessUpdateServer {
    userId: string;
    isThirdParty: boolean;
    isEnabled: boolean;
}

export class UserInfoServer extends UserUpdateServer {
    lastLoginTime: Date;
}

export class UserSearchInfoServer {
    value: UserInfoServer[];
    '@odata.count': number;
}

// CLASSIC SERVER MODELS

export interface IUserServer {
    isDeleted?: boolean;
    apiUserId?: string;
    userGuid: string;
    firstName: string;
    middleName?: string;
    lastName: string;
    email?: string;
}

// Syncs up with V3 public user create API
export type CreateUserServer = {
    firstName: string;
    lastName: string;
    email: string;
    jobTitle: string;
    isCreatedFromForce: boolean;
    sendPasswordEmail: boolean;
    isUsingBetaSite: boolean;
};
